module.exports = __webpack_public_path__ + "img/online-step-3.fa2bd0ae.png";